export default __webpack_public_path__ + "static/calibre2-regular-95501704ff5b94024205cb45ad0bca98.woff2";